import React from 'react';
import { Target, ArrowRight, Check, Users } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const LeadQualificationPage = () => {
  const { login } = useAuth();

  const features = [
    'Qualifique leads automaticamente',
    'Perguntas personalizadas',
    'Scoring de leads',
    'Integração com CRM',
  ];

  const steps = [
    { title: 'Capture', desc: 'O bot captura informações iniciais' },
    { title: 'Qualifique', desc: 'Perguntas automáticas filtram os melhores leads' },
    { title: 'Encaminhe', desc: 'Leads qualificados vão para sua equipe' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Target className="h-4 w-4" />
                Qualificação de Leads
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                <span className="text-[#3b82f6]">Qualifique leads</span> automaticamente
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Deixe o chatbot qualificar seus leads 24/7 e foque apenas nos clientes prontos para comprar.
              </p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">
                Começar gratuitamente
              </Button>
            </div>
            <div className="space-y-4">
              {steps.map((step, i) => (
                <div key={step.title} className="flex items-start gap-4 bg-gray-50 rounded-xl p-4">
                  <div className="w-8 h-8 bg-[#3b82f6] text-white rounded-full flex items-center justify-center font-bold text-sm">{i + 1}</div>
                  <div>
                    <h3 className="font-semibold">{step.title}</h3>
                    <p className="text-sm text-gray-600">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((feature) => (
                <div key={feature} className="bg-white rounded-xl p-6 shadow-sm">
                  <Check className="h-6 w-6 text-green-500 mb-3" />
                  <p className="font-medium text-gray-900">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Comece a qualificar leads agora</h2>
                <Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">
                  Começar agora <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LeadQualificationPage;
